<template>
	<div class="footer">
		<div class="footerMain">
			<div class="footerMainLeft">
				<ul>
					<li v-if="obj.weixin_url_flag">
						<img :src="obj.weixin_url" alt="" />
						<span>微信联系</span>
					</li>
					<!-- <li>
						<img src="../../assets/images/banner1.jpg" alt="" />
						<span>微信打赏</span>
					</li> -->
				</ul>
			</div>
			<div class="footerMainRight">
				<p>
					<b>站点声明：</b>
				</p>
				<p>1、袅袅炊烟起，长河落日急。。。</p>
				<p>2、版权开放，共享信息；若有略同，万分荣幸！！！</p>
				<p>3、Copyright © 2020 <a href="http://beian.miit.gov.cn/" target="_blank">{{obj.record_number}}</a></p>
			</div>
		</div>
	</div>
</template>

<script>	
	export default{
		props:{
			obj:{
				required:true,
				type:Object
			}
		}
	}
	
</script>

<style scoped>
	.footer {
		background: #373D41;
		width: 100%;
		border-top: #00C1DE 10px solid;
		padding: 30px 0;
		color: #73777a;
		font-size: 14px;
	}

	.footerMain {
		width: 1300px;
		margin: auto;
		overflow: hidden;
	}

	.footerMainLeft {
		float: left;
	}

	.footerMainLeft ul {
		overflow: hidden;
	}

	.footerMainLeft ul li {
		float: left;
		margin: 0 10px;
		text-align: center;
	}

	.footerMainLeft ul li img {
		width: 100px;
		height: 100px;
		display: block;
	}

	.footerMainRight {
		float: left;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.footerMainRight p {
		margin-bottom: 5px;
		line-height: 23px;
	}

	.footerMainRight p b {
		font-size: 16px;
		color: #00c1de;
		font-weight: bold;
	}
	.footerMainRight p a {
		color: #73777a;
	}
	.footerMainRight p a:hover {
		color: #00c1de;
	}
</style>
